import React, { useState } from 'react'
import { Colors } from '../constants/colors'

export default (props) => {
    const [val, setval] = useState(props.defaultValue)
    const { options, defaultValue, ...otherProps } = props

    return (
        <div style={otherProps.noStyles ? {} : styles.main}>
            {otherProps.label && otherProps.label !== '' &&
            <label
                style={styles.label}>
                {otherProps.label}
            </label>}
            <div style={{ flex: 0.5 }}>
                <select
                    {...otherProps}
                    key={otherProps.id}
                    onChange={(e) => {
                        setval(e.target.value)
                        if (props.onChange)
                            props.onChange(e)
                    }}
                    value={val}
                >
                    {options}
                </select>
            </div>
        </div>
    )
}

const styles = {
    main: {
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'space-between',
        borderBottomColor: Colors.divider,
        borderBottomWidth: 1
    },
    label: {
        fontSize: 16,
        textAlignVertical: 'center',
        color: '#000',
        flex: 0.5
    },
}